import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface IUserOrgTableProps {
  name: string;
  role: string;
  subscription: string;
}

export const UserOrgColumns = () => {
  const columns: ColumnDef<IUserOrgTableProps>[] = [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0 text-xs"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <p className="text-xs text-primary">{row.getValue('name')}</p>,
    },
    {
      accessorKey: 'role',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0 text-xs"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Role
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <p className="text-xs w-fit px-4 font-medium text-blue-800 py-0.5 bg-blue-200 rounded-full">
          {row.getValue('role')}
        </p>
      ),
    },
    {
      accessorKey: 'subscription',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0 text-xs"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Subscription
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <p className="text-xs px-4 font-medium text-green-800 w-fit py-0.5 bg-green-200 rounded-full">
          {row.getValue('subscription')}
        </p>
      ),
    },
  ];
  return columns;
};
